import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-left">
        <div className="hero-tag">
          <span>Premium Quality</span>
        </div>
        <img src="/logo.png" alt="CASHU Logo" className="hero-logo" />
        <p className="hero-tm-line">Premium Cashew Nuts</p>
        <p className="hero-sub">
          Discover the finest selection of premium cashew nuts, sourced directly from the best farms. 
          Roasted to perfection, packed with nutrients and natural goodness.
        </p>
        <div className="hero-actions">
          <button className="btn-g">Learn More</button>
        </div>
      </div>

      <div className="hero-right">
        <div className="leaf-cluster lc-tl">
          <span>🍃</span>
        </div>
        <div className="leaf-cluster lc-br">
          <span>🍃</span>
        </div>
        <div className="leaf-cluster lc-tr">
          <span>🍃</span>
        </div>
        <img src="/bowl.png" alt="Cashew Bowl" className="hero-bag" />
      </div>
    </section>
  );
}

export default Hero;
